module.exports = __webpack_public_path__ + "img/icon-Social2.d8701eec.png";